// extracted by mini-css-extract-plugin
export default {"container":"UserProfileOption_container__3Y1DN","profile":"UserProfileOption_profile__PMN9R","profileImg":"UserProfileOption_profileImg__+byLx"};